import React, {useState} from 'react';
import NewContactPhoneRow from "./components/new-contact-phone-row";

function NewContactPhoneRows () {

    let defaultPhoneNumberRows = [{
        "id": "0",
        "label":"",
        "number":""
    }];

    const [phoneNumberRows, setPhoneNumbersRows] = useState(defaultPhoneNumberRows);

    const handleNewPhoneRow = () => {
        setPhoneNumbersRows([
            ...phoneNumberRows,
            {
                "id": (parseInt(phoneNumberRows[phoneNumberRows.length - 1].id, 10) + 1).toString(),
                "label":"",
                "number":""
            }
        ])
    };

    const handleDeletePhoneRow = (e) => {
        setPhoneNumbersRows(phoneNumberRows.filter((phoneNumberRow, index) => parseInt(e.currentTarget.dataset.index, 10) !== index));
    };

    return (
        <div className="border-top py-3">
            {
                phoneNumberRows.map((phoneNumberRow, index) => (
                    <NewContactPhoneRow
                        key={phoneNumberRow.id}
                        phoneNumber={phoneNumberRow}
                        index={index}
                        newPhoneRow={handleNewPhoneRow}
                        deletePhoneRow={handleDeletePhoneRow}
                    />
                ))
            }
        </div>
    )

}

export default NewContactPhoneRows;